import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import COLORS from '../../../common/styles/color-pallete';
import { getUTMQueryInString } from '../../../utils/library';
import { SME_URL } from '../../../utils/config';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';
import { CommonButton } from '@Components';
import { CLOSE_NEW_ICON } from '@Images';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 50%;
  background: white;
  /* Light-Grey */

  border: 1px solid ${COLORS.borderGrey};
  box-sizing: border-box;
  box-shadow: 0px 10px 24px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  .cta-button {
    width: 50%;
  }

  @media only screen and (max-width: 1080px) {
    width: 90%;
  }
`;
const Close = styled.div`
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
  cursor: pointer;
`;

const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  button {
    margin-top: 10%;
  }
  text-align: center;
`;

const Title = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${COLORS.black};
  padding-left: 20px;
  padding-bottom: 20px;

  > span {
    font-size: 16px;
    font-weight: 500;
  }
`;

function NewSignUpRedirectModal({ onClose }) {
  const appendUtmQueryString = getUTMQueryInString();
  return (
    <ModalContent className="iframe-modal-outer-wrapper">
      <Close id={'important_info_close_btn'} className="iframe-close-btn">
        <img
          id={'important_info_close_img'}
          src={CLOSE_NEW_ICON}
          alt="close"
          height="20px"
          width="20px"
          onClick={() => onClose(true)}
        />
      </Close>
      <Content className="iframe-modal-content-wrapper">
        <Title className="iframe-modal-title-msg" id={'important_info_title_msg'}>
          Upgraded business onboarding experience
        </Title>
        <p id={'important_info_msg1'}>
          {" We are happy to share that we've upgraded our onboarding "}
          <br />
          {' experience for business accounts. '}
        </p>
        <br />
        <p id={'important_info_msg2'}>
          Visit{' '}
          <a
            id="new_signup_flow_redirect_link"
            style={{ color: COLORS.darkBlue }}
            href={`${SME_URL}/${appendUtmQueryString}`}
          >
            {SME_URL}
          </a>
          {' to register for an account with us! '}
        </p>

        <CommonButton
          className="cta-button iframe-modal-cta-button"
          height={50}
          onClick={() => onClose(true)}
          id={'important_info_msg1-btn'}
          text="Got it"
        />
      </Content>
    </ModalContent>
  );
}

NewSignUpRedirectModal.propTypes = {
  onClose: PropTypes.func
};

export default NewSignUpRedirectModal;
